import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { QuoteNoteRequest, QuoteNoteResponse } from '../models/quote-note.model';

/**
 * Notas internas de una cotización — /api/quotes/{quoteId}/notes (V91).
 *
 * NOTA multi-tenant: businessId y userId salen del JWT (el authInterceptor adjunta
 * el Bearer). NO se envían por query ni body. Rol mínimo: User.
 * Editar/eliminar solo lo permite el backend al autor (403 en caso contrario).
 */
@Injectable({ providedIn: 'root' })
export class QuoteNoteApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  // GET /api/quotes/{quoteId}/notes — array en orden cronológico ascendente.
  getNotes(quoteId: number): Observable<QuoteNoteResponse[]> {
    return this.http.get<QuoteNoteResponse[]>(`${this.apiUrl}/quotes/${quoteId}/notes`);
  }

  // POST /api/quotes/{quoteId}/notes — crea una nota. Los mencionados reciben notificación in-app.
  createNote(quoteId: number, request: QuoteNoteRequest): Observable<QuoteNoteResponse> {
    return this.http.post<QuoteNoteResponse>(`${this.apiUrl}/quotes/${quoteId}/notes`, request);
  }

  // PUT /api/quotes/{quoteId}/notes/{noteId} — edición parcial (SOLO autor; 403 si no).
  updateNote(quoteId: number, noteId: number, request: QuoteNoteRequest): Observable<QuoteNoteResponse> {
    return this.http.put<QuoteNoteResponse>(`${this.apiUrl}/quotes/${quoteId}/notes/${noteId}`, request);
  }

  // DELETE /api/quotes/{quoteId}/notes/{noteId} — 204 (SOLO autor; 403 si no).
  deleteNote(quoteId: number, noteId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/quotes/${quoteId}/notes/${noteId}`);
  }
}
